import { ConfirmDialog, InlineMessage } from "@nexus/ui";
import type { Tenant } from "@/types";

import { apiErrorMessage } from "../useTenantAdmin";

interface DeleteTenantDialogProps {
  tenant: Tenant | null;
  isPending: boolean;
  error: unknown;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteTenantDialog({
  tenant,
  isPending,
  error,
  onClose,
  onConfirm,
}: DeleteTenantDialogProps) {
  return (
    <ConfirmDialog
      open={tenant !== null}
      title="Delete tenant"
      description={
        tenant
          ? `Delete "${tenant.tenant_label}"? Tenants without related data are permanently deleted. Otherwise, the tenant is removed from listings and selections, but its existing data and relationships are retained. This cannot be undone.`
          : ""
      }
      confirmLabel={isPending ? "Deleting..." : "Delete tenant"}
      cancelLabel="Cancel"
      tone="danger"
      pending={isPending}
      onClose={onClose}
      onConfirm={() => {
        if (tenant && !isPending) onConfirm();
      }}
    >
      {error ? (
        <InlineMessage tone="error" title="Tenant could not be deleted">
          {apiErrorMessage(error)}
        </InlineMessage>
      ) : null}
    </ConfirmDialog>
  );
}
